export enum TemplateType {
  KamEmail = 'kam-email',
  WhatsApp = 'whatsapp',
  CemAftersales = 'cem-aftersales',
  MatchMail = 'match-mail',
  PflegiaForFriendsEmail = 'pflegia-for-friends-email',
  Chat = 'chat',
}
